import { TERMS_URL, PRIVACY_URL } from '../../config/constants';
import UrlLink from '../shared/UrlLink';

export const TermsLink = () => (
  <UrlLink href={TERMS_URL} label="利用規約" targetBlank />
);
export const PrivacyLink = () => (
  <UrlLink href={PRIVACY_URL} label="プライバシーポリシー" targetBlank />
);
